<template>
  <div class="q-mt-md promo-container">
    <!-- Header Of the page -->
    <h3 class="text-bold q-m-md inline-block">
      {{ headerMessage }}
    </h3>

    <div class="row">
      <div class="col-8">
        <q-card v-if="getPromoLoading" class="new-tab-loading-wrapper">
          <div>
            <q-spinner color="primary" size="3em" />
          </div>
        </q-card>
        <q-card v-else class="timeline-card">
          <q-card-section>
            <q-tabs
              v-model="eventTab"
              dense
              class="text-grey"
              active-color="primary"
              indicator-color="primary"
              align="justify"
              inline-label
              @update:model-value="(val) => onTabChange(val)"
            >
              <q-tab name="newEventTab" label="New">
                <font-awesome-icon
                  icon="fa-add"
                  size="xl"
                  color="primary"
                  class="q-ml-sm"
                />
              </q-tab>
              <q-tab name="editEventTab" label="Edit ">
                <font-awesome-icon
                  icon="fa-edit"
                  size="xl"
                  color="primary"
                  class="q-ml-sm"
                />
              </q-tab>
            </q-tabs>
            <q-separator />
          </q-card-section>

          <q-card-section>
            <div class="row q-mt-lg">
              <div class="col-6">
                <div>
                  <q-input
                    outlined
                    v-model="currentEvent.eventName"
                    label="Event Name"
                    :rules="[
                      (val) =>
                        val.length >= 3 || 'Please use Minimum 3 characters',
                    ]"
                    lazy-rules
                  />
                </div>
              </div>

              <div class="col-6 flex justify-center">
                <q-date
                  :color="getEnv === 'stage' ? 'secondary' : 'primary'"
                  :text-color="getEnv === 'stage' ? 'black' : 'white'"
                  event-color="red"
                  v-model="selectedEventDatePicker"
                  range
                  mask="MM/DD/YYYY"
                  :options="freeEventDates"
                  @update:model-value="(val) => onChangeEventDate(val)"
                />
              </div>
            </div>
          </q-card-section>
        </q-card>
      </div>
      <div class="col-4 q-pl-md">
        <q-card class="timeline-card">
          <q-card-section class="timeline-card-section">
            <div class="flex no-wrap items-center justify-between">
              <q-input
                v-if="!getPromoLoading"
                borderless
                v-model="searchText"
                input-class="text-left"
                class="q-ml-md"
                :label="
                  getEnv === 'prod' ? 'Production Events' : 'Stage Events'
                "
                @update:model-value="(val) => onSearchChange(val)"
              >
                <template v-slot:prepend>
                  <font-awesome-icon
                    v-if="searchText === ''"
                    icon="fa-search"
                    size="sm"
                    color="primary"
                  />
                  <font-awesome-icon
                    v-else
                    icon="fa-xmark"
                    size="xl"
                    color="primary"
                    name="clear"
                    class="cursor-pointer"
                    @click="() => onSearchChange('')"
                  />
                </template>
              </q-input>
              <q-btn round color="primary" v-if="!getPromoLoading">
                <font-awesome-icon
                  icon="fa-calendar-days"
                  size="xl"
                  color="primary"
                />
                <q-popup-proxy
                  @before-show="updateProxyDateInTimeline"
                  transition-show="scale"
                  transition-hide="scale"
                >
                  <q-date
                    v-model="proxyDate"
                    mask="MM/DD/YYYY"
                    color="grey-2"
                    text-color="black"
                    :options="availableEventsDates"
                  >
                    <div class="row items-center justify-end q-gutter-sm">
                      <q-btn
                        label="Cancel"
                        color="primary"
                        flat
                        v-close-popup
                      />
                      <q-btn
                        label="OK"
                        color="primary"
                        flat
                        @click="setEventSearchDate"
                        v-close-popup
                      />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-btn>
            </div>
          </q-card-section>

          <q-card-section v-if="getPromoLoading">
            <div class="q-ma-md">
              <q-skeleton height="15px" />
              <q-skeleton height="40px" class="q-mt-md" />
            </div>
            <div class="q-ma-md">
              <q-skeleton height="15px" />
              <q-skeleton height="40px" class="q-mt-md" />
            </div>
            <div class="q-ma-md">
              <q-skeleton height="15px" />
              <q-skeleton height="40px" class="q-mt-md" />
            </div>
            <div class="q-ma-md">
              <q-skeleton height="15px" />
              <q-skeleton height="40px" class="q-mt-md" />
            </div>
          </q-card-section>

          <q-card-section v-else>
            <q-timeline>
              <q-timeline-entry
                v-for="event in promoEventsList"
                :key="event.eventKey"
                class="timeline-entry"
                @click="() => timelineEventChange(event)"
                side="left"
                :title="event.eventName"
                :subtitle="
                  displayDatesInTimeline(
                    event.eventDateStart,
                    event.eventDateEnd
                  )
                "
                :color="event.timeLineColor"
              >
                <template v-slot:title>
                  {{ event.eventName }}
                </template>
              </q-timeline-entry>
            </q-timeline>
          </q-card-section>
        </q-card>
      </div>
    </div>

    <div class="relative-class q-mt-lg" v-if="!getPromoLoading">
      <q-btn class="preview-button" flat @click="pauseBanner = !pauseBanner">
        <font-awesome-icon
          :icon="!pauseBanner ? 'fa-play' : 'fa-pause'"
          size="xl"
          :color="pauseBanner ? 'black' : 'red'"
        />
      </q-btn>
      <div
        class="promo-banner-container q-mb-lg"
        :class="!pauseBanner ? 'paused-border' : ''"
      >
        <q-carousel
          class="carousel-wrapper"
          animated
          v-model="slide"
          infinite
          :autoplay="pauseBanner"
          transition-prev="slide-right"
          transition-next="slide-left"
        >
          <q-carousel-slide
            :name="index"
            v-for="(item, index) in currentEventPromos"
            :key="index"
          >
            <q-tabs
              v-model="slide"
              class="text-grey"
              active-color="primary"
              indicator-color="primary"
              align="justify"
              inline-label
            >
              <q-tab
                v-for="(tabs, index) in currentEventPromos"
                :key="index"
                :name="index"
                :label="'slide ' + index"
              />
              <q-tab @click="addNewPromo" :name="currentEventPromos.length">
                <font-awesome-icon
                  icon="fa-add"
                  size="xl"
                  color="primary"
                  class="q-ml-sm"
                />
              </q-tab>
            </q-tabs>
            <PromoPreview
              :imageSrc="
                slideType[index] === 'object'
                  ? item.imageSrc
                  : selectedGameSeoImage
              "
              :title="
                slideType[index] === 'object'
                  ? item.title
                  : selectedGameSeo.GameName
              "
              :description="
                slideType[index] === 'object'
                  ? item.description
                  : selectedGameSeo.PromoDescription
              "
              :link="
                slideType[index] === 'object'
                  ? item.link
                  : selectedGameSeo.FinalURL
              "
              :buttonTitle="
                slideType[index] === 'object' ? item.buttonTitle : 'Play Now'
              "
              :memberOnly="
                slideType[index] === 'object'
                  ? false
                  : isSelectedGameMemberOnly(item)
              "
              class="q-mt-md"
            />
            <q-card flat square>
              <!-- Card Header with slide number, Delete icon and Image icon when 'New Promo' is selected -->
              <q-card-section class="flex promo-wrapper">
                <!-- Select slide to be a Game or a New Promo -->
                <div v-if="currentEvent.stats !== 'closed'">
                  <q-radio
                    v-model="slideType[index]"
                    val="string"
                    label="Game"
                    @click="changeToString(index)"
                  />
                  <q-radio
                    v-model="slideType[index]"
                    val="object"
                    label="New Slide"
                    @click="changeToObj(index)"
                  />
                </div>
                <div
                  class="icons-wrapper"
                  v-if="currentEvent.stats !== 'closed'"
                >
                  <div
                    v-if="slideType[index] === 'object'"
                    class="icon-content"
                    @click="selectImageURL"
                  >
                    <font-awesome-icon icon="image" size="sm" />
                  </div>

                  <div
                    v-if="currentEventPromos.length > 1"
                    class="icon-content q-mx-md"
                    @click="removeSlide(index)"
                  >
                    <q-tooltip self="center left"> Remove Slide</q-tooltip>
                    <font-awesome-icon
                      icon="trash-alt"
                      size="sm"
                    ></font-awesome-icon>
                  </div>
                </div>
              </q-card-section>

              <!-- Change the content to be a JSON editor if a new game or a select if a it's a game -->
              <div>
                <!-- Change the content to be a JSON editor if a new game or a select if a it's a game -->
                <q-card-section>
                  <div class="flex justify-center items-center">
                    <span class="q-mr-md">Slide Position:</span>
                    <q-select
                      class="select-slide-index"
                      dense
                      v-model="slide"
                      outlined
                      :options="slideIndexOptions(index)"
                      :readonly="currentEvent.stats === 'closed'"
                      @update:model-value="(val) => onSelectSlide(val, index)"
                    />
                  </div>
                  <div
                    class="row q-mt-lg flex justify-center"
                    v-if="slideType[index] === 'object'"
                  >
                    <div class="col-5 q-mr-sm">
                      <q-input
                        :readonly="currentEvent.stats === 'closed'"
                        dense
                        outlined
                        v-model="currentEventPromos[index].title"
                        label="Title"
                      />
                      <q-input
                        :readonly="currentEvent.stats === 'closed'"
                        dense
                        class="q-mt-sm"
                        outlined
                        v-model="currentEventPromos[index].imageSrc"
                        label="Image Path"
                      />
                      <q-input
                        :readonly="currentEvent.stats === 'closed'"
                        dense
                        class="q-mt-sm"
                        outlined
                        v-model="currentEventPromos[index].buttonTitle"
                        label="Button Title"
                      />
                      <q-input
                        :readonly="currentEvent.stats === 'closed'"
                        dense
                        class="q-mt-sm"
                        outlined
                        v-model="currentEventPromos[index].link"
                        label="Button Link"
                        :rules="[
                          async (val) =>
                            (await httpCheck(val)) ||
                            'Please start with http:// or https://',
                        ]"
                        reactive-rules
                      />
                      <q-toggle
                        :disable="currentEvent.stats === 'closed'"
                        label="Button link to redirect to a new tab"
                        :color="getEnv === 'stage' ? 'secondary' : 'primary'"
                        v-model="currentEventPromos[index].isTargetBlank"
                      />
                    </div>
                    <div class="col-6">
                      <q-input
                        type="textarea"
                        rows="12"
                        dense
                        outlined
                        v-model="currentEventPromos[index].description"
                        label="Slide Description"
                        :readonly="currentEvent.stats === 'closed'"
                      />
                      <!-- HTML Tips/shortcut to put on banner -->
                      <div>
                        <strong>{{ bannerMessage }}</strong>
                        <font-awesome-icon
                          icon="info-circle"
                          @click="() => (showTips = !showTips)"
                          class="tips-icon"
                        />
                        <span v-if="!showTips"> HTML tips </span>
                        <TipsBanner v-show="showTips" />
                      </div>
                    </div>
                  </div>
                  <q-select
                    v-else
                    v-model="currentEventPromos[index]"
                    class="q-mt-md select-game"
                    dense
                    use-input
                    input-debounce="0"
                    outlined
                    :options="gamesList"
                    option-label="slug"
                    option-value="id"
                    emit-value
                    map-options
                    @update:model-value="(val) => onSelectChange(val, index)"
                    @filter="filterFn"
                    :disable="currentEvent.stats === 'closed'"
                  />
                </q-card-section>
              </div>
            </q-card>
          </q-carousel-slide>
        </q-carousel>
      </div>
      <div class="q-mt-lg q-mb-md flex justify-between">
        <div>
          <q-btn
            v-if="eventTab === 'newEventTab'"
            label="Add Event"
            @click="createEventModal = true"
            color="positive"
            :disable="handlerDisableCreateEvent()"
          />
          <q-btn
            v-else
            label="Edit Event"
            @click="createEventModal = true"
            color="positive"
            :disable="handlerDisableCreateEvent()"
          />
          <q-btn
            v-if="getEnv === 'stage' && isProdEnv"
            class="q-ml-md"
            color="primary"
            label="switch to production"
            @click="sendToProd"
            :disable="currentEvent.eventName.length < 3"
          >
            <q-tooltip self="center left">
              Send fields to Production environment</q-tooltip
            >
            <font-awesome-icon
              class="q-ml-md"
              icon="fa-share"
              size="lg"
              :color="currentEvent.eventName.length < 3 ? 'gray' : 'white'"
            />
          </q-btn>
        </div>
        <div>
          <q-btn
            v-if="eventTab === 'editEventTab'"
            class="q-ml-sm"
            label="Duplicate Event"
            @click="() => duplicateEvent(currentEvent, currentEventPromos)"
            color="primary"
          />
          <q-btn
            v-else
            class="q-ml-sm"
            label="reset event"
            @click="() => newEvent()"
            color="primary"
          />
          <q-btn
            v-if="
              eventTab === 'editEventTab' &&
              this.currentEvent.stats !== 'closed' &&
              this.currentEvent.stats !== ''
            "
            class="q-ml-sm"
            color="negative"
            @click="deleteEventModal = true"
          >
            <font-awesome-icon icon="fa-trash" size="sm" color="negative"
          /></q-btn>
        </div>
      </div>
    </div>

    <q-dialog v-model="createEventModal">
      <q-card class="card-modal">
        <q-card-section>
          <h6 class="q-ml-sm">
            {{ !this.currentEvent.eventKey ? createModalText : editModalText }}
          </h6>
          <strong> ({{ currentEvent.eventName.toUpperCase() }}) </strong>
        </q-card-section>

        <q-card-actions class="flex justify-between q-ma-md">
          <q-btn flat label="Cancel" color="primary" v-close-popup />
          <q-btn label="Confirm" color="positive" @click="createEventConfirm" />
        </q-card-actions>
      </q-card>
    </q-dialog>
    <q-dialog v-model="deleteEventModal">
      <q-card class="card-modal">
        <q-card-section>
          <h6 class="q-ml-sm">{{ deleteModalText }}</h6>
          <strong> ({{ currentEvent.eventName.toUpperCase() }}) </strong>
        </q-card-section>

        <q-card-actions class="flex justify-between q-ma-md">
          <q-btn flat label="Cancel" color="primary" v-close-popup />
          <q-btn label="Delete" color="primary" @click="deleteEventConfirm" />
        </q-card-actions>
      </q-card>
    </q-dialog>
    <SelectImageModal :key="getIsOpenSelectImageModal" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import _ from "lodash";
import SelectImageModal from "../components/modals/SelectImageModal.vue";
import TipsBanner from "@/components/yellowBanner/TipsBanner.vue";
import PromoPreview from "@/components/promos/PromoPreview.vue";
import { errorMessage } from "../errorMessages";
import {
  convertDateIntoAmericanFormat,
  setDateHoursToMidNight,
  setDateHoursToBeforeMidNight,
  showAvailableEventDates,
  getEventByDate,
  datePickerTimelineOptionsFn,
} from "@/utils";

export default {
  name: "PromoView",

  data() {
    return {
      showTips: false,
      htmlTipsText: "Show HTML tips",
      isProdEnv: false,
      eventTab: "newEventTab",
      headerMessage: "Slides Event",
      pauseBanner: false,

      slideType: [],
      slide: 0,

      selectedGameSeo: {},
      selectedGameSeoImage: "",

      promoEventsList: [],
      gamesList: [],
      gameSeoList: [],

      currentEvent: {
        eventName: "",
        eventDateStart: "",
        eventDateEnd: "",
        stats: "",
      },
      currentEventPromos: [],

      initialDate: null,
      proxyDate: null,
      promoEventsFirstDate: "",
      promoEventsLastDate: "",
      selectedEventDatePicker: { from: "", to: "" },
      searchText: "",

      deleteEventModal: false,
      createEventModal: false,
      createModalText: "Are you sure you want to Create the Event?",
      editModalText: "Are you sure you want to Edit the Event?",
      deleteModalText: "Are you sure you want to DELETE the Event?",
      errorMessage,

      convertDateIntoAmericanFormat,
      setDateHoursToMidNight,
      setDateHoursToBeforeMidNight,
      showAvailableEventDates,
      getEventByDate,
      datePickerTimelineOptionsFn,
    };
  },

  components: {
    SelectImageModal,
    PromoPreview,
    TipsBanner,
  },

  async created() {
    this.isProdEnv = process.env.NODE_ENV === "production";
  },

  // Async mounted to wait for API requests
  async mounted() {
    await this.getAllPromos();
    await this.actionGetOldGamesFeed();
    await this.actionGetGamesSeo();
    this.gamesList = _.cloneDeep(this.getGamesList);
    this.gameSeoList = _.cloneDeep(this.getGamesSeoList);

    // Check if the component came from StageToProd and fill with previous stage infos
    if (this.getPromoToProd.eventName && this.getEnv === "prod") {
      this.currentEvent = {
        eventName: this.getPromoToProd.eventName,
        eventDateStart: "",
        eventDateEnd: "",
        stats: "",
      };
      this.currentEventPromos = this.getPromoToProd.promos;
      this.eventTab = "newEventTab";
      this.slide = 0;
      this.handlerRadiosTypes();
      this.gameSeoPromoInfo(this.currentEventPromos[this.slide]);
      this.showGamePromoImage(this.currentEventPromos[this.slide]);
      // Clear persistDate after we fill the form
      this.setPromoToProd({});
    } else {
      this.newEvent();
    }

    // clear persistDate if is Stage
    if (this.getEnv === "stage") {
      this.setPromoToProd({});
    }
  },

  computed: {
    ...mapGetters({
      getPromoEvents: "promo/getPromoEvents",
      getPromoLoading: "promo/getPromoLoading",
    }),
    ...mapGetters({
      getGamesList: "games/getGamesList",
      getGamesSeoList: "games/getGamesSeoList",
    }),
    ...mapGetters({
      getIsOpenSelectImageModal: "selectImage/getIsOpenModal",
    }),
    ...mapGetters({
      getEnv: "selectEnv/getEnv",
    }),
    ...mapGetters({
      getPromoToProd: "generalPersist/getPromoToProd",
    }),
  },

  methods: {
    ...mapActions({
      actionGetPromoEvents: "promo/actionGetPromoEvents",
      actionSetPromoEvents: "promo/actionSetPromoEvents",
      actionDeletePromoEvent: "promo/actionDeletePromoEvent",
    }),
    ...mapActions({
      setSelectImageOpenModal: "selectImage/setOpenModal",
    }),
    ...mapActions({
      actionGetOldGamesFeed: "games/actionGetOldGamesFeed",
      actionGetGamesSeo: "games/actionGetGamesSeo",
    }),
    ...mapActions({
      setPromoToProd: "generalPersist/setPromoToProd",
    }),
    ...mapActions({
      setEnv: "selectEnv/setEnv",
    }),

    async getAllPromos() {
      this.initialDate = new Date().toDateString();
      this.proxyDate = new Date().toDateString();
      await this.actionGetPromoEvents(this.getEnv)
        .then((response) => {
          if (response) {
            this.promoEventsList = _.cloneDeep(response);
          }
          this.promoEventsFirstDate = new Date(
            this.promoEventsList[this.promoEventsList.length - 1].eventDateStart
          ).toDateString();
          this.promoEventsLastDate = new Date(
            this.promoEventsList[0].eventDateEnd
          ).toDateString();
        })
        .catch((err) => {
          console.log("err: ", err);
        });
    },

    sendToProd() {
      this.setPromoToProd({
        eventName: this.currentEvent.eventName,
        eventDateStart: "",
        eventDateEnd: "",
        stats: "",
        promos: this.currentEventPromos,
      });
      this.setEnv("prod");
    },

    newEvent() {
      this.currentEvent = {
        eventName: "",
        eventDateStart: "",
        eventDateEnd: "",
        stats: "",
      };
      this.currentEventPromos = [
        {
          title: "",
          description: "",
          buttonTitle: "",
          link: "",
          imageSrc: "",
          isTargetBlank: true,
        },
      ];
      this.slideType.push("object");
      this.slide = 0;
      this.eventTab = "newEventTab";
      this.selectedGameSeo = {};
      this.selectedGameSeoImage = "";
      this.handlerRadiosTypes();
    },
    async editEvent() {
      this.selectedEventDatePicker = {
        from: this.convertDateIntoAmericanFormat(
          this.currentEvent.eventDateStart
        ),
        to: this.convertDateIntoAmericanFormat(this.currentEvent.eventDateEnd),
      };
      if (this.slideType[0] === "string") {
        this.showGamePromoImage(this.currentEventPromos[0]);
        this.gameSeoPromoInfo(this.currentEventPromos[0]);
      }

      this.eventTab = "editEventTab";
    },
    duplicateEvent(event, promo) {
      this.currentEvent = {
        eventName: event.eventName,
        eventDateStart: "",
        eventDateEnd: "",
        stats: "",
      };
      this.currentEventPromos = promo;
      this.slide = 0;
      this.eventTab = "newEventTab";
      this.handlerRadiosTypes();
    },
    handlerDisableCreateEvent() {
      return (
        this.currentEvent.eventName.length < 3 ||
        this.currentEvent.eventDateStart === "" ||
        this.currentEvent.eventDateEnd === "" ||
        this.currentEvent.stats === "closed"
      );
    },

    onChangeEventDate(val) {
      if (!val) {
        this.currentEvent.eventDateStart = "";
        this.currentEvent.eventDateEnd = "";
      } else if (typeof val === "string") {
        this.currentEvent.eventDateStart = val;
        this.currentEvent.eventDateEnd = val;
      } else {
        this.currentEvent.eventDateStart = val.from;
        this.currentEvent.eventDateEnd = val.to;
      }
    },
    freeEventDates(date) {
      const currentCalendarDate = this.setDateHoursToMidNight(date);
      const today = new Date();
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);
      yesterday.setHours(23, 59, 59, 59);
      if (
        currentCalendarDate < yesterday ||
        this.currentEvent.stats === "closed"
      ) {
        return false;
      } else {
        return this.showAvailableEventDates(
          date,
          this.promoEventsList,
          this.currentEvent,
          this.eventTab
        );
      }
    },

    onTabChange(val) {
      if (val === "newEventTab") {
        this.newEvent();
      } else {
        const clonedEvent = _.cloneDeep(
          this.getEventByDate(new Date().toDateString(), this.promoEventsList)
        );
        if (clonedEvent) {
          this.currentEvent = {
            eventName: clonedEvent.eventName,
            eventDateStart: clonedEvent.eventDateStart,
            eventDateEnd: clonedEvent.eventDateEnd,
            stats: clonedEvent.stats,
            eventKey: clonedEvent.eventKey,
          };
          this.currentEventPromos = clonedEvent.promos;
          this.slide = 0;
          this.eventTab = "editEventTab";
          this.handlerRadiosTypes();
          this.editEvent();
        } else {
          this.newEvent();
        }
      }
    },

    onSearchChange(val) {
      if (val === "") {
        this.searchText = "";
      }
      this.resetPromoEvents();
      this.promoEventsList = this.promoEventsList.filter((product) => {
        return product.eventName.toLowerCase().indexOf(val.toLowerCase()) != -1;
      });
    },
    resetPromoEvents() {
      this.promoEventsList = _.cloneDeep(this.getPromoEvents);
    },
    // Called when user click in a new event from the Timeline
    timelineEventChange(event) {
      this.currentEvent = {
        eventName: event.eventName,
        eventDateStart: event.eventDateStart,
        eventDateEnd: event.eventDateEnd,
        stats: event.stats,
        eventKey: event.eventKey,
      };
      this.currentEventPromos = _.cloneDeep(event.promos);
      this.handlerRadiosTypes();
      this.slide = 0;
      // Update the initial date into a american format, to be displayed in the datepicker
      this.initialDate = this.convertDateIntoAmericanFormat(
        event.eventDateStart
      );
      this.editEvent();
    },
    // save new date in datepicker
    setEventSearchDate() {
      const clonedEvent = _.cloneDeep(
        this.getEventByDate(this.proxyDate, this.promoEventsList)
      );
      if (clonedEvent) {
        this.currentEvent = {
          eventName: clonedEvent.eventName,
          eventDateStart: clonedEvent.eventDateStart,
          eventDateEnd: clonedEvent.eventDateEnd,
          stats: clonedEvent.stats,
          eventKey: clonedEvent.eventKey,
        };
        this.currentEventPromos = clonedEvent.promos;
        this.slide = 0;
        this.eventTab = "editEventTab";
        this.handlerRadiosTypes();
        this.editEvent();
      } else {
        this.$q.notify({
          type: "warning",
          message: `There's no Event at: ${this.convertDateIntoAmericanFormat(
            this.proxyDate
          )}`,
        });
        this.newEvent();
      }
      this.initialDate = this.convertDateIntoAmericanFormat(this.proxyDate);
    },
    // Timeline Date picker functions
    updateProxyDateInTimeline() {
      this.proxyDate = this.convertDateIntoAmericanFormat(this.initialDate);
    },

    availableEventsDates(date) {
      return this.datePickerTimelineOptionsFn(
        date,
        this.promoEventsFirstDate,
        this.promoEventsLastDate
      );
    },

    displayDatesInTimeline(dateStart, dateEnd) {
      return (
        new Date(dateStart).toLocaleDateString("en-us", {
          year: "numeric",
          month: "long",
          day: "numeric",
        }) +
        " - " +
        new Date(dateEnd).toLocaleDateString("en-us", {
          year: "numeric",
          month: "long",
          day: "numeric",
        })
      );
    },

    slideIndexOptions(slideIndex) {
      this.slide = slideIndex;
      const newArr = [];
      for (let index = 0; index < this.currentEventPromos.length; index++) {
        newArr.push(index);
      }
      return newArr;
    },
    onSelectSlide(toIndex, fromIndex) {
      this.moveElement(this.currentEventPromos, fromIndex, toIndex);
      this.slide = toIndex;
      this.handlerRadiosTypes();
    },
    moveElement(array, fromIndex, toIndex) {
      const element = array.splice(fromIndex, 1)[0];
      this.currentEventPromos.splice(toIndex, 0, element);
      return this.currentEventPromos;
    },

    async checkEmptyPromo() {
      let isEmpty = false;
      let emptyMessage = "";
      this.currentEventPromos.map((element) => {
        if (!element || (typeof element === "string" && element === "")) {
          isEmpty = true;
          emptyMessage = "Game promo should NOT be empty.";
        }
        if (typeof element === "object" && !element.link.startsWith("http")) {
          isEmpty = true;
          emptyMessage =
            "Custom Promo links should start with http:// or https://";
        }
      });
      return { isEmpty, emptyMessage };
    },

    async setKeysIntoPromo() {
      this.currentEventPromos.map((promo, index) => {
        if (typeof promo === "object") {
          const keyOne = promo.title
            ? promo.title.replace(/[^a-zA-Z]+/g, "") + "_"
            : "new_promo_" + index.toString() + "_";
          const keyTwo = this.currentEvent.eventDateStart.replace(/\D/g, "");
          promo.key = keyOne.concat(keyTwo);
        }
      });
    },

    async createEventConfirm() {
      const { isEmpty, emptyMessage } = await this.checkEmptyPromo();
      if (isEmpty) {
        this.$q.notify({
          type: "negative",
          message: emptyMessage,
        });
        return;
      }
      await this.setKeysIntoPromo();
      const newPromoEvent = _.cloneDeep({
        ...this.currentEvent,
        promos: this.currentEventPromos,
      });

      this.createEventModal = false;
      await this.actionSetPromoEvents(newPromoEvent)
        .then(async () => {
          await this.getAllPromos();
          this.$q.notify({
            type: "positive",
            message: `The event was successfully ${
              newPromoEvent.eventKey ? "Edited" : "Created"
            }`,
          });
          this.newEvent();
        })
        .catch((err) => {
          this.$q.notify({
            type: "negative",
            message: this.errorMessage(err.response.data.details[0].ErrorCode),
          });
        });
      this.onSearchChange("");
    },
    async deleteEventConfirm() {
      this.deleteEventModal = false;
      await this.actionDeletePromoEvent(this.currentEvent.eventKey)
        .then(async () => {
          await this.getAllPromos();
          this.$q.notify({
            type: "positive",
            message: `The event was successfully Deleted`,
          });
          this.newEvent();
        })
        .catch(() => {
          this.$q.notify({
            type: "negative",
            message: `An error occurred trying to Delete`,
          });
        });
      this.onSearchChange("");
    },
    addNewPromo() {
      this.currentEventPromos.push({
        title: "",
        description: "",
        buttonTitle: "",
        link: "",
        imageSrc: "",
        isTargetBlank: true,
      });
      this.slideType.push("object");
    },
    // Remove current slide
    removeSlide(index) {
      if (index > -1) {
        if (index === this.currentEventPromos.length - 1) {
          this.currentEventPromos.pop();
        } else {
          this.currentEventPromos.splice(index, 1);
        }
        this.slide = 0;
        this.gameSeoPromoInfo(this.currentEventPromos[this.slide]);
        this.showGamePromoImage(this.currentEventPromos[this.slide]);
        this.handlerRadiosTypes();
      }
    },

    newEventTemplate() {
      this.currentEvent = {
        eventName: "",
        eventDateStart: "",
        eventDateEnd: "",
        stats: "",
      };
    },

    // Promos from game
    showGamePromoImage(item) {
      this.selectedGameSeoImage = "";
      let obj = {};
      if (item) {
        this.gamesList.map((element) => {
          if (element.id === item) {
            obj = element;
          }
        });
        if (obj) {
          this.selectedGameSeoImage = obj.assetOriginUrl + obj.promoThumbPath;
          return this.selectedGameSeoImage;
        }
      }
      return "";
    },
    gameSeoPromoInfo(item) {
      this.selectedGameSeo = {};
      if (item) {
        for (const val of this.gameSeoList) {
          if (val.Arena5Slug === item) {
            this.selectedGameSeo = val;
            break;
          }
        }
      }
      return this.selectedGameSeo;
    },
    isSelectedGameMemberOnly(item) {
      let memberOnly = false;
      if (item) {
        this.gamesList.map((element) => {
          if (element.id === item) {
            memberOnly = element.feedMetadata.membersOnly;
          }
        });
        return memberOnly;
      }
      return false;
    },

    // Set the slide Type for all promos
    handlerRadiosTypes() {
      this.slideType = [];
      for (let index = 0; index < this.currentEventPromos.length; index++) {
        const element = this.currentEventPromos[index];
        if (typeof element === "object") {
          this.slideType[index] = "object";
        } else {
          this.slideType[index] = "string";
        }
      }
    },

    async httpCheck(val) {
      return val.startsWith("http");
    },

    // Change the slide type for current slide
    changeToObj(index) {
      this.slideType[index] = "object";
      this.currentEventPromos[index] = {
        title: "",
        description: "",
        buttonTitle: "",
        link: "",
        imageSrc: "",
        isTargetBlank: true,
      };
    },
    changeToString(index) {
      this.slideType[index] = "string";
      this.currentEventPromos[index] = "";
      this.selectedGameSeo = {};
      this.selectedGameSeoImage = "";
    },

    onSelectChange(val, index) {
      const value = val === null ? "" : val;
      this.slideType[index] = "string";
      this.currentEventPromos[index] = value;
      this.gameSeoPromoInfo(value);
      this.showGamePromoImage(value);
    },

    // Filter search game by names
    filterFn(val, update) {
      if (val === "") {
        update(() => {
          this.gamesList = _.cloneDeep(this.getGamesList);
        });
        return;
      }

      update(() => {
        const needle = val.toString().toLowerCase();
        this.gamesList = this.getGamesList.filter(
          (game) =>
            game.id.toString().toLowerCase().indexOf(needle) > -1 ||
            (game.name &&
              game.name.toString().toLowerCase().indexOf(needle) > -1)
        );
      });
    },

    selectImageURL() {
      this.setSelectImageOpenModal(true);
    },
  },

  watch: {
    slide() {
      if (this.slideType[this.slide] === "string") {
        this.gameSeoPromoInfo(this.currentEventPromos[this.slide]);
        this.showGamePromoImage(this.currentEventPromos[this.slide]);
      }
    },

    currentEvent() {
      this.selectedEventDatePicker = {
        from: this.convertDateIntoAmericanFormat(
          this.currentEvent.eventDateStart
        ),
        to: this.convertDateIntoAmericanFormat(this.currentEvent.eventDateEnd),
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.promo-wrapper {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  background-color: $secondary;
}

.new-tab-loading-wrapper {
  min-height: 60vh;
  position: relative;
  div {
    position: absolute;
    left: 50%;
    top: 10%;
  }
}

.promo-title {
  font-size: 24px;
}

.icons-wrapper {
  padding: 0 10px;
  margin-left: auto;
  font-size: 24px;
  color: $primary;
  transition: all 0.4s ease-in-out;
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon-content {
  cursor: pointer;
  &:hover {
    color: $red;
  }
}

.add-icon {
  font-size: 40px;
  color: $positive;
  cursor: pointer;
  transition: all 0.4s ease-in-out;
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    color: $lighterGreen;
  }
}

.promo-banner-container {
  position: relative;
  width: 100%;
  min-height: 260px;
  background-color: $white;
  box-shadow: 0 1px 4px rgb(0 0 0 / 35%);
}

.paused-border {
  border: solid 2px red;
  border-radius: 4px;
}

.carousel-wrapper {
  height: 100% !important;
}

.q-carousel {
  :deep(.q-carousel__slide) {
    padding: 0 !important;
  }
}

.relative-class {
  position: relative;
}

.timeline-card {
  position: relative;
  max-height: 60vh;
  height: 60vh;
  overflow: scroll;
  overflow-x: hidden;
}

.timeline-entry {
  cursor: pointer !important;
}
.timeline-card-section {
  position: sticky;
  min-height: 80px;
  top: 0;
  background-color: rgb(241, 241, 241);
  z-index: 2;
  width: 100%;
}

.custom-button {
  cursor: pointer;

  .rotate-top {
    transition: all 0.3s ease;
    transform: rotate(0deg) !important;
  }

  .rotate-bottom {
    transition: all 0.3s ease;
    transform: rotate(-180deg) !important;
  }
}
.preview-button {
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 0px 0px;
  border-bottom: none;
  z-index: 1;
  border-radius: 10px 10px 0 0;
}

.select-slide-index {
  width: 70px;
}

.select-game {
  width: 500px;
}

.card-modal {
  width: 600px;
  max-width: 80vw;
}

// Tips class inside TipsBanner component
.tips {
  border-radius: 4px;
  width: max-content;
  padding: 1em;
  background-color: #c2f8ff;
}
.tips-icon {
  cursor: pointer;
}
</style>
